<template>
    <div>
        <MainNavigation :routeIndex="routeIndex" />
        <NotificationBar v-if="!teacherInfo.isFirstTime" :msg-text="'Welcome back ' + teacherInfo.name +'!'" />
        <NotificationBar v-if="teacherInfo.isFirstTime && allClasses.length"
            :msg-text="'Congratulations! ' + teacherInfo.name +' You’ve added your first class. Now select the class from the list below to add your student list.'" />
        <div class="my-class-header">
            <h2>My Classes</h2>
            <div v-if="allClasses.length">
                <button class="add-class" type="button" @click="editMode = !editMode" v-if="editMode == false">
                    Edit Classes
                </button>
                <button class="add-class" type="button" @click="editMode = !editMode" v-if="editMode == true">
                    Finish Edit
                </button>
                <router-link to="new-class">
                    <button class="add-class" type="button">Add a Class</button>
                </router-link>
            </div>
        </div>
        <Loader v-if="!allClasses.length" />
        <ClassItems v-if="allClasses.length" :editMode="editMode" :allClasses="allClasses" />
        <Modal v-show="newClassAdded">
            <template v-slot:header>
                <b></b>
            </template>
            <template v-slot:body>
                <b>New Class Added!</b>
            </template>
            <template v-slot:footer>
                <div class="modal-button-group"><b></b></div>
            </template>
        </Modal>
        <Modal v-show="classRemoved">
            <template v-slot:header>
                <b></b>
            </template>
            <template v-slot:body>
                <b>Class Deleted!</b>
            </template>
            <template v-slot:footer>
                <div class="modal-button-group"><b></b></div>
            </template>
        </Modal>
    </div>
</template>

<script>
    import MainNavigation from "../components/MainNavigation.vue";
    import NotificationBar from "../components/NotificationBar.vue";
    import Loader from "../components/Loader.vue";
    import ClassItems from "../components/ClassItems.vue";
    import Modal from "../components/Modal.vue";

    export default {
        name: "ClassList",
        components: {
            MainNavigation,
            NotificationBar,
            ClassItems,
            Loader,
            Modal,
        },
        props: ["routeIndex"],
        data() {
            return {
                editMode: false,
            };
        },
        computed: {
            teacherInfo() {
                return this.$store.state.teacherInfo;
            },
            allClasses() {
                return this.$store.state.allClasses;
            },
            newClassAdded() {
                return this.$store.state.newClassAdded;
            },
            classRemoved() {
                return this.$store.state.classRemoved;
            }
        },
        watch: {
            classRemoved: function () { // watch it
                setTimeout(() => {
                    this.$store.commit("SET_CLASS_REMOVED", false);
                    this.$router.go();
                }, 2000);
            },
            allClasses: function () {
                setTimeout(() => {
                    if (this.allClasses.length === 0) {
                        this.$router.push({ name: 'add-class' });
                    }
                }, 2000);
            },
             newClassAdded: function() {
                this.$router.go();
             }
        },
        mounted() {
            if (this.newClassAdded) {
                setTimeout(() => this.$store.commit("SET_NEWCLASS_ADDED", false), 2000);
            }
        }
    };
</script>

<style lang="scss">
    .add-class a {
        color: #fff;
        text-decoration: none;
    }

    .my-class-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        div {
            display: flex;

            a {
                text-decoration: none;
            }
        }

        button {
            width: 150px;

            &.add-class {
                margin: 1rem 0rem 1rem 1em;
            }
        }

        @media only screen and (max-width: 500px) {
            flex-direction: column;
            align-items: start;

            button {
                width: 120px;
                font-size: 0.9em;

                &.add-class {
                    margin: 0px 0.5rem 1.5rem 0px;
                }
            }
        }
    }

    .my-class-header p {
        font-size: 24px;
        text-align: center;
    }

    .style1 {
        border-color: #008ddb;
    }

    .style2 {
        border-color: #ead936;
    }

    .style3 {
        border-color: #e8243d;
    }

    .style4 {
        border-color: #8d2212;
    }

    .style5 {
        border-color: #122f8d;
    }
</style>